import { IAppState } from 'shared/common/state';

export const isOpenSelector = (state: IAppState): boolean => {
  return state.consultantCianChat?.isOpened || false;
};
